import { Stack, Typography, ButtonBase } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

// dayjs.day(): 0 = nedelja ... 6 = subota
const DAY_KEYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

export default function DateStrip({ selectedDate, onDateChange }) {
    const { t } = useTranslation();
    const selected = dayjs(selectedDate);
    const today = dayjs().startOf("day");

    const daysFromToday = selected.diff(today, "day");
    const daysBefore = Math.min(daysFromToday, 3);
    const startDay = selected.subtract(daysBefore, "day");

    const days = Array.from({ length: 7 }, (_, i) => startDay.add(i, "day"));

    return (
        <Stack
            direction="row"
            spacing={0}
            sx={{
                bgcolor: "white",
                borderRadius: 2,
                overflow: "hidden",
                border: "1px solid",
                borderColor: "grey.200",
            }}
        >
            {days.map((day) => {
                const isSelected = day.format("YYYY-MM-DD") === selected.format("YYYY-MM-DD");
                const isPast = day.isBefore(today, "day");
                const dayOfWeek = day.day();

                return (
                    <ButtonBase
                        key={day.format("YYYY-MM-DD")}
                        onClick={() => !isPast && onDateChange(day.format("YYYY-MM-DD"))}
                        disabled={isPast}
                        sx={{
                            flex: 1,
                            py: 1.5,
                            px: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            bgcolor: isSelected ? "primary.main" : "transparent",
                            color: isSelected ? "white" : isPast ? "grey.300" : "text.primary",
                            cursor: isPast ? "not-allowed" : "pointer",
                            transition: "all 0.2s",
                            borderRight: "1px solid",
                            borderColor: "grey.100",
                            "&:last-child": { borderRight: "none" },
                            "&:hover": {
                                bgcolor: isSelected ? "primary.main" : isPast ? "transparent" : "grey.50",
                            },
                            "&.Mui-disabled": {
                                color: "grey.300",
                                opacity: 0.6,
                            },
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: isSelected ? 700 : 500,
                                fontSize: { xs: "0.7rem", md: "0.85rem" },
                            }}
                        >
                            {t(`weekdays.${DAY_KEYS[dayOfWeek]}`)}
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{
                                fontWeight: isSelected ? 700 : 400,
                                color: isSelected ? "rgba(255,255,255,0.85)" : isPast ? "grey.300" : "text.secondary",
                                fontSize: { xs: "0.65rem", md: "0.75rem" },
                            }}
                        >
                            {day.format("DD.MM.YYYY")}
                        </Typography>
                    </ButtonBase>
                );
            })}
        </Stack>
    );
}
